import { ActionType, Actions } from '../actions';

export const refreshPage = (draft = 0, action: ActionType): number => {
  switch (action.type) {
    case Actions.SET_REFRESH_PAGE:
      draft = Math.random();
      return draft;
    default:
      return draft;
  }
};
